import React, { useEffect } from "react";
import { MDBTooltip } from "mdb-react-ui-kit";
import { successMsg } from "../SuccessHandler";
import TransparentTextInput from "../TransparentTextInput";
import ErrorCodes from "../../constants/ErrorCodes";
import { useDeleteFunctions } from "../../functions";
import ConfirmDialog from "../utilities/ConfirmDialog";

const TrackCategoryTable = ({
  trackCategory,
  setTrackCategory,
  data,
  divRef,
  tableRef,
  shouldFocusLast,
  setHasChanges,
  setShouldFocusLast,
  sessionNoLongerExists,
  setSessionNoLongerExists,
}) => {
  const { deleteTrackCategory } = useDeleteFunctions();

  //Highlights the last track inserted in the track table
  useEffect(() => {
    if (shouldFocusLast && tableRef.current) {
      if (tableRef.current) {
        const rows = tableRef.current.getElementsByTagName("tr");
        const secondLastRow = rows[rows.length - 6];
        const lastRow = rows[rows.length - 3];
        secondLastRow.style.backgroundColor = null;
        lastRow.style.backgroundColor = "#b3f0ff";
        lastRow.scrollIntoView();
      }
      const div = divRef.current;
      if (div) {
        div.scrollTop = div.scrollHeight;
      }

      setShouldFocusLast(false);
    }
  }, [shouldFocusLast]);

  //Onchange Categories Table
  const categoriesTableChangeHandler = (e) => {
    const x = [...trackCategory];
    let name = e.target.name;
    let key = e.target.getAttribute("data-key");
    let value = e.target.value;

    if (name === "CategoryOrder") {
      value = parseInt(e.target.value);
    }

    x[key][name] = value;
    x[key]["Change"] = true;

    setTrackCategory(x);
    setHasChanges(true);
  };

  // Delete Categories Function
  const deleteCategory = (categoryID, i, categoryName) => {
    ConfirmDialog(
      `Do you want to delete the <strong>${categoryName}</strong> Category?`
    ).then(async (result) => {
      if (result.isConfirmed) {
        const res = await deleteTrackCategory(
          {
            DeleteID: categoryID,
          },
          data
        );

        if (res?.error) {
          if (
            res.Result === ErrorCodes.InvalidSession ||
            res.Result === ErrorCodes.SessionNoLongerExists
          ) {
            setSessionNoLongerExists(true);
          }

          return;
        } else {
          successMsg("Delete Category successfully");
          const updatedItems = [...trackCategory];
          updatedItems.splice(i, 1);
          setTrackCategory(updatedItems);
        }
      }
    });
  };

  // Charge Open Bets Table
  let headers,
    headersDetails,
    tableContent = [];

  // Associated profile headers
  headersDetails = (
    <tr className="text-center">
      <th className="font-weight-normal">Profile</th>
      <th className="font-weight-normal">Limit Set</th>
    </tr>
  );

  // Changes the details icon in the categories table when you click on the
  const handleIconClick = (event) => {
    const icon = event.target;
    if (icon.classList.contains("icon-plus")) {
      icon.classList.remove("icon-plus");
      icon.classList.add("icon-minus");
    } else {
      icon.classList.remove("icon-minus");
      icon.classList.add("icon-plus");
    }
  };
  // The table of categories is loaded
  if (trackCategory) {
    tableContent = trackCategory.map((row, i) => {
      let detailsContent;
      if (row.LimitSet) {
        row.LimitSet.length !== 0
          ? (detailsContent = row.LimitSet.map((item, j) => {
              return (
                <tr key={"tr" + j}>
                  <td className="text-center">{item.Profile}</td>
                  <td className="text-center">{item.LimitSet}</td>
                </tr>
              );
            }))
          : (detailsContent = (
              <tr>
                <td colSpan={2} style={{ textAlign: "center" }}>
                  No associated profiles
                </td>
              </tr>
            ));
      }
      return (
        <React.Fragment key={i}>
          <tr key={"tr" + i}>
            <td key={"IdTrackCategory" + i} className="d-none">
              {row.IDTrackCategory}
            </td>
            {/* Order */}
            <td
              key={"Order" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
                width: "130px",
              }}
            >
              <TransparentTextInput
                id="CategoryOrder"
                name="CategoryOrder"
                type="number"
                dataKey={i}
                onChange={(event) => categoriesTableChangeHandler(event)}
                error={row.CategoryOrder < 0 ? true : false}
                value={row.CategoryOrder}
                errorLabel="Order cannot be negative"
              />
            </td>

            {/* Description */}
            <td
              key={"Desc" + i}
              style={{ verticalAlign: "middle", textAlign: "center" }}
            >
              <TransparentTextInput
                id="Description"
                name="Description"
                type="text"
                dataKey={i}
                onChange={(event) => categoriesTableChangeHandler(event)}
                error={!row.Description ? true : false}
                value={row.Description}
                errorLabel="Order cannot be negative"
              />
            </td>

            {/* Details */}
            <td
              style={{
                textAlign: "center",
                verticalAlign: "middle",
              }}
              key={"det" + i}
            >
              <MDBTooltip
                tag="i"
                wrapperProps={{ href: "#" }}
                title="Profile/Limit Set"
              >
                <i
                  className="fas fa-plus fa-bold"
                  style={{
                    color: "#117888",
                    fontSize: "20px",
                    cursor: "pointer",
                  }}
                  href="#!"
                  data-toggle="collapse"
                  data-target={"#collapseDetails" + row.IDTrackCategory}
                  aria-expanded="false"
                  onClick={handleIconClick}
                ></i>
              </MDBTooltip>
            </td>

            {/* Delete */}
            <td
              style={{
                textAlign: "center",
                verticalAlign: "middle",
              }}
              key={"del" + i}
            >
              <MDBTooltip tag="i" wrapperProps={{ href: "#" }} title="Delete">
                <i
                    className="fas fa-trash-alt"
                  style={{
                    color: "#ff0000",
                    fontSize: "20px",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    deleteCategory(row.IDTrackCategory, i, row.Description)
                  }
                ></i>
              </MDBTooltip>
            </td>
          </tr>
          <tr
            id={"collapseDetails" + row.IDTrackCategory}
            className="collapse card-body"
            aria-labelledby="headingDetails"
            style={{
              textAlign: "left",
              padding: "5px",
            }}
            key={"details" + row.IDTrackCategory}
          >
            <td
              colSpan={6}
              key={"limits" + row.IDTrackCategory}
              style={{ whiteSpace: "unset" }}
            >
              <div>
                <p
                  className="lead mt-1 mb-1"
                  style={{
                    color: "#8c8c8c",
                    fontSize: "16px",
                    textAlign: "center",
                    marginBottom: "0px",
                  }}
                >
                  Profile / Limit Set Combinations
                </p>
                <table
                  className="table table-striped table-sm mb-1"
                  style={{ width: "70%", margin: "0 auto" }}
                >
                  <thead
                    className=""
                    style={{
                      backgroundColor: "#0e6471",
                      color: "#fff",
                    }}
                  >
                    {headersDetails}
                  </thead>
                  <tbody>{detailsContent}</tbody>
                </table>
              </div>
            </td>
          </tr>
        </React.Fragment>
      );
    });
  }

  // Table headers tracks
  headers = (
    <tr className="text-center">
      <th hidden>CategoryID</th>
      <th>Order</th>
      <th>Description</th>
      <th></th>
      <th></th>
    </tr>
  );

  return (
    <>
      <div
        className="divTables"
        style={{ overflow: "auto", marginTop: "10px" }}
        ref={divRef}
      >
        <table className="table table-striped table-sm " ref={tableRef}>
          <thead style={{ position: "sticky", top: "0", background: "white" }}>
            {headers}
          </thead>
          <tbody className="table-lg">{tableContent}</tbody>
        </table>
      </div>
    </>
  );
};

export default TrackCategoryTable;
